import React from 'react';

import BlockButton from './EditorTextArea.BlockButton';
import IndentBlockButton from './EditorTextArea.IndentBlockButton';
import IndentListButton from './EditorTextArea.IndentListButton';
import LinkButton from './EditorTextArea.LinkButton';
import MarkButton from './EditorTextArea.MarkButton';
import RedoButton from './EditorTextArea.RedoButton';
import UndoButton from './EditorTextArea.UndoButton';
import styles from './EditorTextArea.less';
import type { EditorTextAreaProps } from './index';

const isVisible = (toolbar: EditorTextAreaProps['toolbar'], group: string) => {
  if (!toolbar) return true;
  const { options } = toolbar;

  return options ? options.includes(group) : false;
};

const Toolbar = ({ toolbar }: { toolbar: EditorTextAreaProps['toolbar'] }) => (
  <div className={styles.toolbar}>
    {isVisible(toolbar, 'inline') && (
      <div className={styles.group}>
        <MarkButton format="bold" />
        <MarkButton format="italic" />
        <MarkButton format="underline" />
        <MarkButton format="strikethrough" />
      </div>
    )}
    {isVisible(toolbar, 'list') && (
      <div className={styles.group}>
        <BlockButton format="ol" />
        <BlockButton format="ul" />
      </div>
    )}
    {isVisible(toolbar, 'indent-list') && (
      <div className={styles.group}>
        <IndentListButton direction="indent" />
        <IndentListButton direction="outdent" />
      </div>
    )}
    {isVisible(toolbar, 'indent-block') && (
      <div className={styles.group}>
        <IndentBlockButton direction="indent" />
        <IndentBlockButton direction="outdent" />
      </div>
    )}
    {isVisible(toolbar, 'block') && (
      <div className={styles.group}>
        <BlockButton format="left" />
        <BlockButton format="center" />
        <BlockButton format="right" />
        <BlockButton format="justify" />
      </div>
    )}
    {isVisible(toolbar, 'link') && <LinkButton />}
    {isVisible(toolbar, 'history') && (
      <div className={styles.group}>
        <UndoButton />
        <RedoButton />
      </div>
    )}
  </div>
);

export default Toolbar;
